export default "__VITE_ASSET__C0eciv93__"